import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.7 7.137a.983.983 0 0 0-1.4 0L9 12.318V.978C9 .391 8.6 0 8 0S7 .391 7 .978v11.34L1.7 7.137a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368l7 6.843c.1.098.2.196.3.196.1.098.3.098.4.098s.3 0 .4-.098.2-.098.3-.196l7-6.843a.93.93 0 0 0 0-1.368"
    }, null, -1)
  ]))]))
}
export default { render: render }